/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback, useMemo } from 'react';

// 📌 Material UI v6
import { Typography, Chip, Box } from '@mui/material';

// 📌 Componentes compartidos
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
} from 'components';

// 📌 Redux
import { useDispatch } from 'react-redux';
import { getFPByMeter, fpConsume } from 'js/actions/meterDashboardActions';

// 📌 Otras librerías
import ReactSpeedometer from 'react-d3-speedometer';
import { useIntl } from 'react-intl';

export default function FPGauge({ meterId, meterFp }) {
  const intl = useIntl();
  const dispatch = useDispatch();

  // Estados para almacenar valores de FP
  const [fpRolado, setFPRolado] = useState('0');
  const [fpRealTime, setFPRealTime] = useState('0');
  const [fpMesAnterior, setFPMesAnterior] = useState('0');
  const [mesAnterior, setMesAnterior] = useState(0);
  const [selFPId, setSelFPId] = useState(null);

  // Obtiene el año y el mes actual
  const currentDate = useMemo(() => new Date(), []);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;

  // Lista de nombres de los meses traducidos
  const meses = useMemo(
    () => [
      intl.formatMessage({ id: 'app.months.jan' }),
      intl.formatMessage({ id: 'app.months.feb' }),
      intl.formatMessage({ id: 'app.months.mar' }),
      intl.formatMessage({ id: 'app.months.apr' }),
      intl.formatMessage({ id: 'app.months.may' }),
      intl.formatMessage({ id: 'app.months.jun' }),
      intl.formatMessage({ id: 'app.months.jul' }),
      intl.formatMessage({ id: 'app.months.ago' }),
      intl.formatMessage({ id: 'app.months.sep' }),
      intl.formatMessage({ id: 'app.months.oct' }),
      intl.formatMessage({ id: 'app.months.nov' }),
      intl.formatMessage({ id: 'app.months.dec' }),
    ],
    [intl]
  );

  // Maneja la respuesta de consumo de FP y realiza las solicitudes necesarias
  const getFPResponse = useCallback(
    (data) => {
      if (data && data.length > 0) {
        const fpId = meterFp || data[0].id;
        setSelFPId(fpId);

        dispatch(
          fpConsume(
            fpId,
            `${year}${month}01`,
            `${year}${month}30`,
            0,
            0,
            getFPRoladoConsumeResponse
          )
        );
        dispatch(
          fpConsume(
            fpId,
            `${year}${month}01`,
            `${year}${month}30`,
            0,
            0,
            getFPRealTimeConsumeResponse
          )
        );
        dispatch(
          fpConsume(
            fpId,
            `${year}${month}01`,
            `${year}${month}30`,
            0,
            0,
            getFPPrevMonth
          )
        );
      }
    },
    [dispatch, meterFp, year, month]
  );

  useEffect(() => {
    if (meterId) {
      dispatch(getFPByMeter(meterId, getFPResponse));
      setMesAnterior(month === '01' ? 12 : month - 1);
    }
  }, [dispatch, meterId, getFPResponse]);

  if (!selFPId) {
    return null;
  }

  // Funciones para manejar las respuestas de consumo de FP
  const getFPRoladoConsumeResponse = (data) => {
    if (data && typeof data === 'object' && 'value' in data) {
      setFPRolado(Math.floor(parseFloat(data.value) * 100).toString());
    }
  };

  const getFPPrevMonth = (data) => {
    if (data && typeof data === 'object' && 'value' in data) {
      setFPMesAnterior(Math.floor(parseFloat(data.value) * 100).toString());
    }
  };

  const getFPRealTimeConsumeResponse = (data) => {
    if (data && typeof data === 'object' && 'value' in data) {
      setFPRealTime(Math.floor(parseFloat(data.value) * 100).toString());
    }
  };

  return (
    <Portlet style={{ height: 400 }}>
      <PortletHeader noDivider>
        <PortletLabel
          title={intl.formatMessage({ id: 'app.meter.board.fpWidget.title' })}
        />
      </PortletHeader>
      <PortletContent>
        <Box
          sx={{
            fontFamily: 'Lato, Helvetica Neue, Arial',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <ReactSpeedometer
            currentValueText={`${parseFloat(fpRolado) || 0}%`}
            customSegmentStops={[70, 80, 90, 100]}
            fontFamily={'Lato, Helvetica Neue, Arial'}
            height={150}
            maxValue={100}
            minValue={70}
            needleColor={'#000'}
            needleHeightRatio={0.7}
            ringWidth={30}
            segmentColors={['#EB0000', '#FAC800', '#00C454']}
            segmentValueFormatter={(value) => `${value}%`}
            textColor={'#000'}
            value={parseFloat(fpRolado) || 0}
            valueTextFontSize={'16px'}
            valueTextFontWeight={'600'}
            width={180}
          />
          <Chip
            sx={{
              mt: 2,
              fontWeight: 'bold',
              color: '#fff',
              bgcolor: '#730065',
            }}
            label={`${intl.formatMessage({ id: 'app.meter.board.fpWidget.closeLabel' })} ${meses[mesAnterior - 1]}`}
          />
          <Typography
            sx={{
              fontFamily: 'Lato, Helvetica Neue, Arial',
              mt: 2,
              fontWeight: 600,
              textAlign: 'center',
            }}
            variant="h5"
          >
            {parseFloat(fpMesAnterior) || 0}%
          </Typography>
        </Box>
      </PortletContent>
    </Portlet>
  );
}
